export const COLORS = {
    primary: '#EE8595',
    secondary: '#838282',
    darkGray: '#383838',
    approxGrey: '#838282'
}